export default async function sendPostMessage(data) {
	const frame = document.getElementById('astra-starter-templates-preview');
	const siteUrl = starterTemplates.site_home_url;

	frame.contentWindow.postMessage({
		call: "starterTemplatePreviewDispatch",
		value: data
	},
		siteUrl
	);
};
